export function invertColor(hex) {
  if (hex.indexOf('#') === 0) {
    // eslint-disable-next-line no-param-reassign
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    // eslint-disable-next-line no-param-reassign
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // http://stackoverflow.com/a/3943023/112731
  // Возвращает true, если цвет должен белый, false - если черный
  return !((r * 0.299 + g * 0.587 + b * 0.114) > 186);
}
export default { invertColor };
